<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="3">
        <b-form-group>
          <b-form-input
            v-model="QueryByZip"
            placeholder="Zipcode"
            autocomplete="off"
            type="text"
            id="QueryByZip"
            v-mask="'#####'"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Radius</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="DefaultRadius"
              placeholder="Radius"
              autocomplete="off"
              type="text"
              id="DefaultRadius"
              v-mask="'###'"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="9">
        <QueryByZipMap />
      </b-col>

      <b-col sm="3">
        <b-row
          v-if="QueryByZip.length == 5"
          class="primary-row divider-row-thin"
        >
          <b-col sm="12"><h4 class="text-center">Details</h4></b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <ZipCard v-if="QueryByZip.length == 5" />
          </b-col>
        </b-row>
        <b-row
          v-if="QueryByZip.length == 5"
          class="primary2-row divider-row-thin"
        >
          <b-col sm="12">
            <h4 class="text-center">Usage</h4>
          </b-col>
        </b-row>
        <b-row v-if="QueryByZip.length == 5 && !zip.zip_usage_map.length">
          <b-col sm="12"><h4 class="text-center">None</h4></b-col>
        </b-row>
        <b-row v-if="QueryByZip.length == 5 && zip.zip_usage_map.length">
          <b-col sm="12">
            <b-table
              :items="zip.zip_usage_map"
              :fields="fields"
              hover
              small
              fixed
              caption
              selectable
              select-mode="single"
              responsive="sm"
              selectedVariant="success"
            ></b-table>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import QueryByZipMap from "@/components/maps/QueryByZipMap.vue";
import ZipCard from "@/components/cards/ZipWithChecksCard.vue";
import { mapState } from "vuex";
import cTable from "@/views/base/Table.vue";

export default {
  components: {
    QueryByZipMap,
    cTable,
    ZipCard
  },
  computed: {
    ...mapState(["globals", "n_user", "zip"])
  },
  data: () => {
    return {
      QueryByZip: "",
      DefaultRadius: 10,
      conflicts_instance: [],
      fields: [
        {
          key: "TerritoryName",
          label: "Territory",
          sortable: true
        },
        {
          key: "DateOfSeating",
          label: "Date",
          sortable: true
        },
        {
          key: "Restaurant",
          label: "Restaurant",
          sortable: true
        }
      ]
    };
  },
  created() {
    this.LoadMyComponents();
  },
  mounted() {},

  methods: {
    async LoadMyComponents() {
      await this.$store.dispatch("zip/fetchZipSymbols");
      this.QueryByZip = "";
      this.$store.dispatch("globals/setQueryByZip", "");
    },
    refreshWait() {
      if (this.timer) {
        window.clearTimeout(this.timer);
      }
      this.timer = window.setTimeout(() => {
        this.timer = null;
        this.loadMap(this);
      }, 2000);
    }
  },
  watch: {
    QueryByZip: function(newValue, oldValue) {
      if (newValue.length === 5) {
        this.$store.dispatch("globals/setQueryByZip", newValue);
        this.refreshWait;
        this.$store.dispatch("zip/getUsageMap", newValue);
      }
    },
    DefaultRadius: function(newValue, oldValue) {
      this.$store.dispatch("globals/setQueryByZipRadius", newValue);
    },
    "$store.state.zip.zip_usage": function(newValue) {},
    "$store.state.globals.query_by_zip": function(newValue) {
      if (newValue.length === 5) {
        this.QueryByZip = newValue;
        this.$store.dispatch("globals/setQueryByZipObject", newValue);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
